import { createReducer } from '@reduxjs/toolkit'

import { ICategory } from 'types/GlobalCategory'

import * as actions from '../../actions/Categories/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface CategoryReducerType {
  data: {
    [slug: string]: ICategory
  }
  fetched: boolean
}

// Initial state
const INITIAL_STATE: CategoryReducerType = {
  data: {},
  fetched: false
}

// Reducer
const categoryReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      const { payload } = action
      const data: { [title: string]: ICategory } = {}

      payload.forEach((item) => {
        data[item.slug] = item
      })

      return {
        ...state,
        data,
        fetched: true
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default categoryReducer
